import React from 'react';
import { Badge, Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

export interface FilterToggleOption {
  value: string;
  label: string;
  badgeCount?: number;
}

interface FilterToggleGroupProps {
  value: string;
  onChange: (value: string) => void;
  options: FilterToggleOption[];
  size?: 'small' | 'medium' | 'large';
}

export const FilterToggleGroup: React.FC<FilterToggleGroupProps> = ({
  value,
  onChange,
  options,
  size = 'small',
}) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    size={size}
    onChange={(_, v) => { if (v !== null) onChange(v); }}
  >
    {options.map(opt => (
      <ToggleButton key={opt.value} value={opt.value}>
        {opt.badgeCount && opt.badgeCount > 0 ? (
          <Badge
            badgeContent={opt.badgeCount}
            color="warning"
            max={99}
            sx={{ '& .MuiBadge-badge': { fontSize: '0.6rem', minWidth: 16, height: 16, top: -2, right: -6 } }}
          >
            <Box sx={{ pr: 1 }}>{opt.label}</Box>
          </Badge>
        ) : opt.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
